import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, isDevMode, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { PoTemplatesModule } from '@po-ui/ng-templates';
import { Configuration, MingleService } from '@totvs/mingle';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';

export function configMingle(mingle: MingleService): () => Promise<any> {
  const config = new Configuration();
  config.app_identifier = environment.app_identifier;
  config.environment = environment.environment;
  config.server = environment.server;
  config.modules.web = environment.web;
  config.modules.usage_metrics = environment.usage_metrics;

  mingle.setConfiguration(config);
  return (): Promise<any> => mingle.init();
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    PoTemplatesModule,
    FormsModule,
    RouterModule.forRoot([]),
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    MingleService,
    {
      provide: APP_INITIALIZER,
      useFactory: configMingle,
      deps: [MingleService],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
